<div class="background {{ bgColor }}">
  <div class="page-section" [class.mobile]="rwdService.isSmallDevice">
    <div class="filter-panel">
      <div class="filters">
        <ng-content select="[filters]"></ng-content>
      </div>
      <div class="panel" *ngIf="loaded; else templateService.loader">
        <ng-content select="[content]"></ng-content>
      </div>
    </div>
    <div class="panel" *ngIf="!rwdService.isSmallDevice">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<div *ngIf="selected && rwdService.isSmallDevice" style="display: none">
  <!-- HACK: Needed to move to dialog on window width change - forces to repaint component and activate mobile (dialog) version -->
  <router-outlet></router-outlet>
</div>
